// NewFolderModal.tsx
import React, { useState } from 'react';
import * as Dialog from '@radix-ui/react-dialog';
import { Button } from '../../../../components/ui/button';
import { Input } from '../../../../components/ui/input';
import { FolderPlus } from 'lucide-react';

interface NewFolderModalProps {
  onNewFolder: (folderName: string) => void;
  disabled?: boolean;
}

const NewFolderModal: React.FC<NewFolderModalProps> = ({
  onNewFolder,
  disabled,
}) => {
  const [folderName, setFolderName] = useState('');
  const [open, setOpen] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (folderName.trim()) {
      onNewFolder(folderName.trim());
      setFolderName('');
      setOpen(false);
    }
  };

  return (
    <Dialog.Root open={open} onOpenChange={setOpen}>
      <Dialog.Trigger asChild>
        <Button
          variant="customSecondary"
          className="gap-2 text-[14px] bg-secondary"
          size="sm"
          disabled={disabled}
        >
          <FolderPlus size={16} />
          New Folder
        </Button>
      </Dialog.Trigger>

      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 bg-black/50 backdrop-blur-sm" />
        <Dialog.Content className="fixed left-1/2 top-1/2 w-[400px]  lg:w-[28vw] -translate-x-1/2 -translate-y-1/2 rounded-lg bg-background-main p-6 shadow-lg text-text-primary">
          <Dialog.Title className="text-xl text-primary  font-semibold mb-4">
            Create New Folder
          </Dialog.Title>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="flex flex-col gap-2">
              <label htmlFor="folderName" className="text-sm font-medium">
                Folder Name
              </label>
              <Input
                id="folderName"
                value={folderName}
                onChange={(e) => setFolderName(e.target.value)}
                placeholder="Enter folder name"
                className="w-full"
                autoFocus
              />
            </div>

            <div className="mt-6 flex justify-end gap-3">
              <Dialog.Close asChild>
                <Button
                  type="button"
                  variant={'customSecondary'}
                  className="bg-secondary text-primary"
                >
                  Cancel
                </Button>
              </Dialog.Close>
              <Button
                type="submit"
                variant={'customSecondary'}
                className="bg-secondary text-primary"
                disabled={!folderName.trim()}
              >
                Create Folder
              </Button>
            </div>
          </form>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};

export default NewFolderModal;
